
































import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import RequestPromises from "@/mixins/requestPromises";
import HasValidation from "@/mixins/HasValidation";

// Enums
import { DataModules } from "@/store/modules/data";

// Types
import {
  IProvisionRequest,
  IBlueprintField,
  IProvisionRetryRequestForm
} from "@/models/provisioning";

@Component({
  components: {
    "provision-field": () =>
      import(
        "@/components/app/admin/catalogue/products/provisioning/provisionField.vue"
      )
  }
})
export default class ContractProductFunctionFieldsModal extends Mixins(
  RequestPromises,
  HasValidation
) {
  // Props

  @Prop({ required: true })
  public requestId!: IProvisionRequest["id"];

  @Prop({ required: true })
  public requestFields!: IBlueprintField[];

  // Data

  public form = {
    provision_field_values: {},
    dispatch_now: true
  } as IProvisionRetryRequestForm;
  public formClone = {
    provision_field_values: {},
    dispatch_now: true
  } as IProvisionRetryRequestForm;
  public isProcessing = false;

  // Life-cycle methods

  public created() {
    this.initializeForm();
  }

  // Methods

  public initializeForm() {
    this.$_.forEach(this.requestFields, field => {
      this.$set(
        this.form.provision_field_values,
        `${field.name}`,
        field.default_value
      );
    });

    this.formClone = this.$_.cloneDeep(this.form);
  }

  public async validateBeforeSubmit() {
    try {
      if (!(await this.validate()))
        throw this.$t("_sentence.form_is_not_valid");

      this.isProcessing = true;
      const request = await this.retryRequest();

      this.$emit("success", request);
      this.$emit("close");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  public retryRequest(): Promise<IProvisionRequest> {
    return this.$store.dispatch(
      `data/${DataModules.PROVISIONING_REQUESTS}/retryRequest`,
      {
        id: this.requestId,
        data: {
          ...this.form
        }
      }
    );
  }

  public get focusedFieldId() {
    return this.$_.get(
      this.$_.find(this.requestFields, ["staff_can_update", true]),
      "id"
    );
  }
}
